const state = () => ({
  min: null,
  max: null,
})

const actions = {
  setYearModelMin({ commit }, value) {
    commit('SET_YEARMODEL_MIN', value)
  },
  setYearModelMax({ commit }, value) {
    commit('SET_YEARMODEL_MAX', value)
  },
  clearYearModel({ commit }) {
    commit('CLEAR_YEARMODEL')
  },
}

const mutations = {
  SET_YEARMODEL_MIN(state, value) {
    state.min = value
  },
  SET_YEARMODEL_MAX(state, value) {
    state.max = value
  },
  CLEAR_YEARMODEL(state) {
    state.min = null
    state.max = null
  },
}

const getters = {
  getYearModelMin: (state) => state.min,
  getYearModelMax: (state) => state.max,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
